import { useSession } from "@/modules/auth/hooks/useSession"
import type { FindexUser } from "@/types/models/user";
import { computed } from "vue";

export const useCurrentUser = () => {
  const session = useSession();
  const user = computed(() => session.state.user as FindexUser);
  return {
    user
  }
}
